module.exports = __webpack_public_path__ + "img/javieragrez.6176367e.jpg";